// extracted by mini-css-extract-plugin
export default {"container":"component_form_radio_container__EaJJb","checkboxGroup":"component_form_radio_checkboxGroup__JGlN8"};